import React, { Component } from "react";
import { Form } from "antd";
import { ENV } from "@/services/utils";
import FormCreate from "../../../../../components/FormCreate/index";
import styles from "./NormForm.less";

const { FormTitle, FormTextArea, FormInputNumber, FileUpload } = FormCreate;

@Form.create()
class NormForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: "",
      name: "",
      remark: "",
      appendix: "",
      score: "",
      measurement: "",
      checkPoint: "",
      from: "",
      templateType: "",
      type: "",
      filesNumber: 0
    };
  }

  componentDidMount() {
    const { form, onEdit } = this.props;
    const {
      number,
      name,
      remark,
      appendix,
      score,
      measurement,
      checkPoint,
      from,
      templateType,
      type
    } = this.props;
    this.setState({
      number,
      name,
      measurement,
      remark,
      score,
      appendix,
      checkPoint,
      from,
      templateType,
      type
    });
    if (typeof onEdit === "function") {
      onEdit({
        number,
        name,
        measurement,
        remark,
        checkPoint,
        score,
        appendix,
        form
      });
    }
  }

  handleFileGroupId = (fileId, length) => {
    const { form, onEdit } = this.props;
    this.setState(
      {
        appendix: fileId,
        filesNumber: length
      },
      () => {
        const {
          number,
          name,
          remark,
          appendix,
          score,
          measurement,
          checkPoint
        } = this.state;
        if (typeof onEdit === "function") {
          onEdit({
            number,
            name,
            measurement,
            remark,
            checkPoint,
            score,
            appendix,
            form
          });
        }
      }
    );
  };

  // 表单框变化的回调
  handleValueChange = (e, valueType) => {
    const {
      number,
      name,
      remark,
      appendix,
      score,
      measurement,
      checkPoint
    } = this.state;
    const { form, onEdit } = this.props;

    // 因为当是分数时，传进来的不是事件e，而是分分数值
    if (valueType === "score") {
      this.setState({ score: e }, () => {
        const { score: newValueName } = this.state;
        if (typeof onEdit === "function") {
          onEdit({
            number,
            name,
            measurement,
            remark,
            checkPoint,
            score: newValueName,
            appendix,
            form
          });
        }
      });
    } else {
      this.setState({ [valueType]: e.target.value }, () => {
        const { [valueType]: newValueName } = this.state;
        if (typeof onEdit === "function") {
          onEdit({
            number,
            name,
            measurement,
            remark,
            checkPoint,
            score,
            appendix,
            form,
            [valueType]: newValueName
          });
        }
      });
    }
  };

  render() {
    const {
      number,
      name,
      remark,
      appendix,
      score,
      measurement,
      checkPoint,
      from,
      templateType,
      type,
      filesNumber
    } = this.state;
    const { form } = this.props;

    const isShowNowForm =
      templateType === 1 || templateType === 2 || type === 1 || type === 2;

    const normNumberProps = {
      form,
      value: number,
      label: "指标编号",
      keyName: "numberName",
      maxLength: 10,
      suffix: `${(number && number.length) || 0}/10`,
      onChange: e => this.handleValueChange(e, "number")
    };

    const normNameProps = {
      form,
      value: name,
      label: "指标名称",
      keyName: "indexName",
      maxLength: 100,
      rows: 5,
      isRequired: true,
      suffix: `${(name && name.length) || 0}/100`,
      onChange: e => this.handleValueChange(e, "name")
    };

    const normMeasurementProps = {
      form,
      value: measurement,
      label: "评估标准",
      keyName: "measurement",
      maxLength: 1000,
      rows: 5,
      isRequired: true,
      suffix: `${(measurement && measurement.length) || 0}/1000`,
      onChange: e => this.handleValueChange(e, "measurement")
    };

    const normRemarkProps = {
      form,
      value: remark,
      label: "备注说明",
      keyName: "remark",
      maxLength: 1000,
      rows: 5,
      isRequired: false,
      suffix: `${(remark && remark.length) || 0}/1000`,
      onChange: e => this.handleValueChange(e, "remark")
    };

    const normCheckPointProps = {
      form,
      value: checkPoint,
      label: "量化考核点",
      keyName: "checkPoint",
      maxLength: 1000,
      rows: 5,
      isRequired: true,
      suffix: `${(checkPoint && checkPoint.length) || 0}/1000`,
      onChange: e => this.handleValueChange(e, "checkPoint")
    };

    const normScoreProps = {
      form,
      value: score,
      label: "指标分值",
      keyName: "score",
      rows: 5,
      isRequired: true,
      step: 0.1,
      precision: 2,
      // formatter: value => {
      //   const v = Number(value);
      //   const i = Math.floor(v);
      //   const c = v - i;
      //   if (c >= 0.5) {
      //     return `${i + 0.5}分`;
      //   }
      //   return `${i + 0.0}分`;
      // },
      // parser: value => {
      //   const v = Number(value.replace("分", ""));
      //   const i = Math.floor(v);
      //   const c = v - i;
      //   if (c >= 0.5) {
      //     return i + 0.5;
      //   }
      //   return i;
      // },
      onChange: e => this.handleValueChange(e, "score")
    };

    const normFileProps = {
      form,
      groupId: appendix,
      APIEnv: ENV,
      type: "pc",
      handleFileGroupId: this.handleFileGroupId,
      fileCount: filesNumber
    };

    return (
      <div className={styles.normForm}>
        <FormCreate>
          <FormTitle {...normNumberProps} />
          <FormTextArea {...normNameProps} />
          <FormTextArea {...normMeasurementProps} />
          {isShowNowForm && <FormTextArea {...normRemarkProps} />}
          {isShowNowForm && <FormTextArea {...normCheckPointProps} />}
          {isShowNowForm && <FormInputNumber {...normScoreProps} />}
          <FileUpload {...normFileProps} />
        </FormCreate>
      </div>
    );
  }
}

export default NormForm;
